import BookmarkLoader from '@/bookmarks/bookmark_loader'
import BookmarkCounter from '@/bookmarks/bookmark_counter'
import BookmarkAdd from '@/bookmarks/bookmark_add'
import BookmarkItem from '@/bookmarks/bookmark_item'
import BookmarkListEmpty from '@/bookmarks/bookmark_list_empty'
import BookmarkRemove from '@/bookmarks/bookmark_remove'

export default ($context = document) => {
  $(() => {
    $('.js-bookmark-add', $context).each(function () {
      new BookmarkAdd($(this))
    })

    $('.js-bookmark-list-empty', $context).each(function () {
      new BookmarkListEmpty($(this))
    })

    $('.js-bookmarks-total', $context).each(function () {
      new BookmarkCounter($(this))
    })

    $('.js-bookmark-remove', $context).each(function () {
      new BookmarkRemove($(this))
    })

    $('.js-bookmark-item', $context).each(function () {
      new BookmarkItem($(this), '.js-bookmark-link')
    })

    $('.js-bookmarks-loader', $context).each(function () {
      new BookmarkLoader($(this))
    })
  })
}
